import { render, staticRenderFns } from "./ContentDetail.vue?vue&type=template&id=7ac980e8&scoped=true&"
import script from "./ContentDetail.vue?vue&type=script&lang=js&"
export * from "./ContentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ContentDetail.vue?vue&type=style&index=0&id=7ac980e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac980e8",
  null
  
)

export default component.exports